import { fontFamilyToString } from './fontFamilyToString';
export const screensNumber = {
  sm: 640,
  md: 768,
  lg: 1000,
  xl: 1280,
  '2xl': 1366,
  '3xl': 1920,
  ipad: 1024
};
const SEARCH_TERM_COLORS = ['yellow', '#afff9d', '#e2c1ff', '#cdcbff', '#8bffb7', '#e2b1f9', '#ffd280', '#97ffff'];
export function getSearchTermColor(i) {
  return SEARCH_TERM_COLORS[i % 8];
}
export const screens = {
  sm: `${screensNumber.sm}px`,
  md: `${screensNumber.md}px`,
  lg: `${screensNumber.lg}px`,
  xl: `${screensNumber.xl}px`,
  '2xl': `${screensNumber['2xl']}px`,
  '3xl': `${screensNumber['3xl']}px`,
  ipad: `${screensNumber.ipad}px`
};
export const colors = {
  /** Interchangeable color palettes */
  palettes: {
    primary: {
      main: '#0094FF',
      dark: '#006EAC',
      contrastText: '#fff'
    },
    error: {
      main: '#FF0101',
      dark: '#D50000',
      contrastText: '#fff'
    },
    delete: {
      light: '#f89c9c',
      main: '#DF6E6E',
      dark: '#b85b5b',
      contrastText: '#fff'
    },
    warning: {
      main: '#FF9900',
      dark: '#FF9900',
      contrastText: '#fff'
    }
  },
  input: {
    border: '#BFE5F1',
    focusedBorder: '#7ADAF9',
    adornment: '#62BDFF',
    disabledBackground: '#F4F4F4',
    disabledBorder: '#DADFE2',
    disabledText: '#777777'
  },
  specialOptions: {
    none: '#FFE607',
    notEmpty: '#47ff8a',
    mine: '#47ff8a'
  },
  action: {
    disabledBackground: '#dddddd'
  },
  background: {
    default: '#f4f9f7',
    paper: '#fff',
    paperTransparent: '#ffffffb3',
    semiTransparent: '#ffffff4d',
    fullTransparent: '#ffffff00',
    form: '#ffffff',
    formTransparent: '#ffffffb3',
    formDarkened: '#ffffff',
    formHovered: '#ffffff',
    dialog: '#f4f9f7',
    header: '#00b79f',
    headerBorder: '#dff6f3',
    navItemActive: '#90ff00',
    loginScreen: '#eafff6',
    highlighted: '#fdffb1',
    dropdown: {
      hoverItemBackground: 'rgba(0, 148, 255, 0.09);',
      selectItemBackground: 'rgba(0, 148, 255, 0.28)',
      selected: '#E9FBFF'
    },
    tag: {
      green: '#56FB2D',
      blue: '#C9E8FF',
      gray: '#D3D3D3',
      lightBlue: '#ecf6fd'
    },
    tableHeader: '#eafff6',
    tableHeaderArchived: '#dddddd80',
    tableHeaderDark: '#E4F5FF',
    tableHeaderInactive: '#F4F4F4',
    status: {
      open: '#FFFFFF',
      failed: '#FFFFFF',
      sent: '#82D2FF',
      converted: '#56FB2D',
      paid: '#56FB2D',
      void: '#666',
      expired: '#999999',
      'checking out': '#FBE62D',
      refunded: '#BB7777',
      'partially refunded': '#bb9577',
      'partially paid': '#009090',
      locked: '#C0FFFF',
      error_deleting: 'linear-gradient(90deg, #EA7979 0%, #FFFFFF 100%)',
      error_suspending: 'linear-gradient(90deg, #EB8181 0%, #808080 100%)',
      deleting: 'linear-gradient(90deg, #B1F99F 0%, #FFFFFF 100%)',
      deleted: '#ffffff',
      suspending: 'linear-gradient(90deg, #B3FFA1 0%, #808080 100%)',
      suspended: '#808080'
    }
  },
  text: {
    primary: '#444444',
    secondary: '#808080',
    faint: '#888888',
    tableHeader: '#0094FF',
    disabled: '#777777',
    hint: '#AEAEAE',
    archivedRow: '#757575',
    negative: '#C87800',
    errorText: '#D50000',
    tableErrorText: '#BB7777',
    note: '#686868',
    permission: '#ffbb00',
    received: '#5F8D53',
    sent: '#006EAC',
    notice: '#8951FF'
  },
  icons: {
    default: '#626262'
  },
  strip: {
    white: '#fff',
    stainless: '#bbb',
    black: '#000',
    blue: '#0D87BE',
    green: '#149D38',
    brown: '#9B7F05',
    orange: '#F39E30',
    red: '#F3323A',
    pink: '#FB6ABD',
    purple: '#CE7AF7',
    default: '#F9F9F9'
  },
  toasts: {
    success: '#2BD600',
    cancel: '#FFE607',
    warning: '#FF9900',
    error: '#D40000',
    draft: '#FFFFFF',
    archive: '#FFFF00'
  },
  chart: {
    bar: '#82D2FF',
    label: '#0C8AB3'
  },
  pieChart: ['#78CEFF', '#98D9FF', '#B8E5FF', '#D3EFFF', '#EAF7FF', '#F9FDFF'],
  editor: {
    disabledButton: '#00000036',
    pressedButton: '#0094FF29'
  },
  transparent: 'transparent',
  current: 'currentColor',
  black: '#000',
  white: '#fff',
  gray: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827'
  },
  red: {
    50: '#fef2f2',
    100: '#fee2e2',
    200: '#fecaca',
    300: '#fca5a5',
    400: '#f87171',
    500: '#ef4444',
    600: '#dc2626',
    700: '#b91c1c',
    800: '#991b1b',
    900: '#7f1d1d'
  },
  yellow: {
    50: '#fffbeb',
    100: '#fef3c7',
    200: '#fde68a',
    300: '#fcd34d',
    400: '#fbbf24',
    500: '#f59e0b',
    600: '#d97706',
    700: '#b45309',
    800: '#92400e',
    900: '#78350f'
  },
  green: {
    50: '#ecfdf5',
    100: '#d1fae5',
    200: '#a7f3d0',
    300: '#6ee7b7',
    400: '#34d399',
    500: '#10b981',
    600: '#059669',
    700: '#047857',
    800: '#065f46',
    900: '#064e3b'
  },
  blue: {
    50: '#eff6ff',
    100: '#dbeafe',
    200: '#bfdbfe',
    300: '#93c5fd',
    400: '#60a5fa',
    500: '#3b82f6',
    600: '#2563eb',
    700: '#1d4ed8',
    800: '#1e40af',
    900: '#1e3a8a'
  },
  lightBlue: '#82D2FF',
  indigo: {
    50: '#eef2ff',
    100: '#e0e7ff',
    200: '#c7d2fe',
    300: '#a5b4fc',
    400: '#818cf8',
    500: '#6366f1',
    600: '#4f46e5',
    700: '#4338ca',
    800: '#3730a3',
    900: '#312e81'
  },
  purple: {
    50: '#f5f3ff',
    100: '#ede9fe',
    200: '#ddd6fe',
    300: '#c4b5fd',
    400: '#a78bfa',
    500: '#8b5cf6',
    600: '#7c3aed',
    700: '#6d28d9',
    800: '#5b21b6',
    900: '#4c1d95'
  },
  pink: {
    50: '#fdf2f8',
    100: '#fce7f3',
    200: '#fbcfe8',
    300: '#f9a8d4',
    400: '#f472b6',
    500: '#ec4899',
    600: '#db2777',
    700: '#be185d',
    800: '#9d174d',
    900: '#831843'
  }
};

// Use namespace so that inputHelper can reference sans.
// eslint-disable-next-line @typescript-eslint/no-namespace
export let fontFamily;
(function (_fontFamily) {
  const sans = _fontFamily.sans = fontFamilyToString(['Lato', 'ui-sans-serif', 'system-ui', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Helvetica Neue', 'Arial', 'Noto Sans', 'sans-serif', 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji']);
  const serif = _fontFamily.serif = fontFamilyToString(['ui-serif', 'Georgia', 'Cambria', 'Times New Roman', 'Times', 'serif']);
  const mono = _fontFamily.mono = fontFamilyToString(['ui-monospace', 'SFMono-Regular', 'Menlo', 'Monaco', 'Consolas', 'Liberation Mono', 'Courier New', 'monospace']);
  const inputHelper = _fontFamily.inputHelper = `Oswald, ${sans}`;
})(fontFamily || (fontFamily = {}));